import axios from "axios";

export default {
  async search(payload) {
    let url = `/parent-contracts/search?search=${payload.searchString}`
    return axios.get(url);
  },
  async getAll() {
    let url = `/parent-contracts`
    return axios.get(url);
  },
};